import { FC, useContext, useEffect, useState } from "react";
import { Box, Button, CircularProgress, Dialog, Grid, IconButton, Typography } from "@material-ui/core";
import useStyles from "../../Styles/ProjectModalStyles";
import ProjectPoolHeading from "../../Projects/ProjectPoolHeading";
import { MdClose, MdError } from "react-icons/md";
import web3Helper from "../../../services/web3";
import AlertContext from "../../../store/Alert/AlertContext";

const WithdrawModal: FC<any> = ({ open, setOpen, tokenName, contractAddress, stakeDetails, stakeDuration, toggleHasStaked, hasPenalty, withdrawDetails, withdrawDetailsError }: any) => {

    const classes = useStyles();

    const { setAlert } = useContext<any>(AlertContext);

    const [isLoading, toggleLoading] = useState<boolean>(false);
    
    const isExpired = new Date((Number(stakeDetails?.startTime) * 1000) + stakeDuration * 1000) < new Date();

    useEffect(() => {
      if (withdrawDetailsError) setAlert('We were unable to fetch withdraw details, withdrawal disabled, try later', 'error');
    }, [])

    const handleClose = (event: React.SyntheticEvent<any, Event>, reason: string) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
    }

    const handleWithdraw = (event: React.SyntheticEvent<any, Event>, reason: string) => {
      toggleLoading(true);
      web3Helper.withdrawPartnerStake(contractAddress)
      .then((receipt: any) => {
        // TODO: Show success modal
        toggleHasStaked(false);
        toggleLoading(false);
        setOpen(false);
        setAlert('You have successfully withdrawn your tokens', 'success');
      })
      .catch((error: any) => {
        setAlert('Unable to execute withdraw transaction at the moment, please try later', 'error')
        toggleLoading(false);
      })
    }

    return (
        <>
            <Box component="section">
                <Dialog
                    open={open}
                    onClose={handleClose}
                    className={classes.modalpages}
                    aria-labelledby="contribution"
                    aria-describedby="contribution-result"
                    disableEscapeKeyDown={false}
                    maxWidth="sm"
                >
                    <Grid
                        container
                        style={{
                            padding: "20px",
                            display: "block"
                        }}
                        direction="column"
                    >
                        <Grid item lg={12}>
                          <Grid container style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: 'center',
                        }}>
                            <Grid item>
                              <ProjectPoolHeading title1="Withdraw" title2={tokenName} />
                            </Grid>
                            <Grid item>
                              <IconButton
                                  edge="end"
                                  color="inherit"
                                  aria-label="close"
                                  onClick={(event) => handleClose(event, 'buttonClick')}
                              >
                                  <MdClose />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid 
                            item
                            lg={12}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Grid
                              container
                              direction="column"
                              className={classes.detailContainer}
                            >
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Staked
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      <span className="detailValue">{stakeDetails?.amountStaked} {tokenName}</span>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Staked On
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      {new Date(Number(stakeDetails?.startTime) * 1000).toLocaleDateString()}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Expiry Date
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      {new Date((Number(stakeDetails?.startTime) * 1000) + stakeDuration * 1000).toLocaleDateString()}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Expired
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      <span className="detailValue">{stakeDetails?.expired ? "Yes" : "No"}</span>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Early Withdrawals With Penalty
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      <span className="detailValue">{hasPenalty ? "Yes" : "No"}</span>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Reward
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      {
                                        withdrawDetailsError
                                          ? <MdError color="red" />
                                          : <Typography>
                                              <span className="detailValue">{withdrawDetails.rewardAmount} {tokenName}</span>
                                            </Typography>
                                      }
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item>
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Grid item>
                                    <Typography>
                                      Total Withdrawal Amount
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={true}>
                                    <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                                  </Grid>
                                  <Grid item>
                                    <Typography>
                                      {
                                        withdrawDetailsError
                                          ? <MdError color="red" />
                                          : <Typography>
                                              <span className="detailValue">{withdrawDetails.amountToWithdraw} {tokenName}</span>
                                            </Typography>
                                      }
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                        >
                            <Grid 
                                container
                                justifyContent="center"
                                lg={12}
                                direction="row"
                                style={{
                                    marginTop: "20px",
                                }}
                                spacing={2}
                            >
                                <Grid item lg={10} xs={10} md={10} sm={10}>
                                  <Button variant="contained" color="primary" fullWidth onClick={(e) => handleWithdraw(e, 'buttonClick')} disabled={isLoading || withdrawDetailsError || (!hasPenalty && !isExpired)} style={{
                                    minHeight: '40px',
                                  }}>
                                    {
                                      isLoading
                                        ? <CircularProgress variant="indeterminate" size={10} thickness={2} color="secondary" />
                                        : "Withdraw"
                                    }
                                  </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Dialog>
            </Box>
        </>
    )
}

export default WithdrawModal;